// @spec RSK-STR-048
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { AISuggestionsPage } from '@/features/rsk/components/ai';
import { useOrganizations } from '@/hooks/use-organizations';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/risks/ai-suggestions')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.aiLeon'),
  }),
  component: AIRiskSuggestionsRoute,
});

function AIRiskSuggestionsRoute() {
  const { t } = useTranslation('common');
  const { organizations, isLoading: orgsLoading } = useOrganizations();
  const activeOrg = organizations.find((org) => org.isActive);

  if (orgsLoading) {
    return (
      <div className="min-h-screen bg-background p-8">
        <div className="mx-auto max-w-6xl">
          <div className="animate-pulse space-y-4">
            <div className="h-8 w-48 rounded bg-muted" />
            <div className="h-12 rounded bg-muted" />
            <div className="h-64 rounded bg-muted" />
          </div>
        </div>
      </div>
    );
  }

  if (!activeOrg) {
    return (
      <div className="min-h-screen bg-background p-8">
        <div className="mx-auto max-w-6xl">
          <div className="rounded-lg border border-dashed p-12 text-center">
            <h2 className="text-lg font-semibold text-foreground">{t('common:routeErrors.noOrgSelected')}</h2>
            <p className="mt-2 text-muted-foreground">
              {t('common:routeErrors.noOrgSelectedDesc')}
            </p>
            <Button variant="outline" className="mt-4">
              {t('common:routeErrors.goToOrganizations')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return <AISuggestionsPage orgId={activeOrg.id} />;
}
